import type { IRamConfig } from '@/shared/env/types';
import type { IUser } from '@condo/domain';
import type { User as FirebaseUser } from 'firebase/auth';

/**
 * Builds Unleash context for user targeting.
 * Only includes dynamic properties (userId, properties) that can be updated at runtime.
 * Static properties (appName, environment) are set during client initialization only.
 *
 * Source: services/core/cockpit/src/shared/unleash-context.ts
 */
export function buildRamUnleashContext(
    config: IRamConfig,
    firebaseUser: FirebaseUser | null,
    domainUser: IUser | null,
): {
    userId?: string;
    properties?: Record<string, string>;
} {
    return {
        userId: domainUser?.uid ?? firebaseUser?.uid,
        ...(domainUser?.email ? { properties: { email: domainUser.email } } : {}),
    };
}
